import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import Link from "react-router-dom/Link";
import { func, arrayOf, objectOf, bool } from "prop-types";
import { actions as layoutActions } from "reducers/layout";
import { actions, selectors } from "reducers/settings";
import { resizableRoute } from "pages/_components/Resizable";
import { dispatchV3ShellLayout, isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import { getArray } from "util/config";
import { goBack } from "react-router-redux";
import { Checkbox as CheckBoxComponent } from "pages/_components/fields/Checkbox";
import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Image from "pages/_components/Image";

const HIDDEN_NOTIFICATION_TYPES = [
    "marketing",
    "tmpLimitApproved",
    "tmpLimitRejected",
    "temporaryLimitApproved",
    "temporaryLimitRejected",
    "ImplLimitApproved",
    "ImplLimitRejected",
    "implLimitApproved",
    "implLimitRejected",
];

class NotificationsConfiguration extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        communicationTypes: arrayOf(objectOf(bool)),
        fetching: bool.isRequired,
        isDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        communicationTypes: [],
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { dispatch, embeddedInV3Shell } = this.props;

        dispatch(actions.notificationsConfigurationPre());
        if (embeddedInV3Shell && isUxDashboardImprovementsEnabled()) {
            dispatchV3ShellLayout(dispatch, {
                titleKey: "settings.notificationsConfiguration",
                goBackPath: "/settings",
                rightContentMobile: null,
                scopes: ["settings"],
            });
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell && isUxDashboardImprovementsEnabled()) {
            dispatch(layoutActions.setScopes([]));
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setHeaderTitle(""));
            dispatch(layoutActions.setHeaderSubtitle(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
        }
    }

    renderTitleMobile = () => (
        <div>
            <h1 className="m-0 align-center">
                <I18n id="settings.notificationsConfiguration" />
            </h1>
        </div>
    );

    renderCommunicationTypes = () => {
        const { communicationTypes } = this.props;
        const typesNecesaryWithPush = ["pending", "tmpLimitIncrease"];
        const configuredHiddenTypes = getArray("core.communications.nonConfigurableTypes", []);
        const hiddenTypes = new Set(
            [...HIDDEN_NOTIFICATION_TYPES, ...configuredHiddenTypes].map((type) => type.toLowerCase()),
        );

        return communicationTypes
            .filter((communicationType) => {
                const [key] = Object.entries(communicationType)[0];
                // Muestra si no tinenen push o si tienen push y estan en la variable typesNecesaryWithPush
                const isVisibleByPush = !communicationType.subscribed_push || typesNecesaryWithPush.includes(key);
                return isVisibleByPush && !hiddenTypes.has(key.toLowerCase());
            })
            .map((communicationType) => {
                const [key, value] = Object.entries(communicationType)[0];

                return (
                    <li className="navigational-list-item" key={key}>
                        <Link to={`/settings/notificationsConfiguration/${key}`}>
                            <CheckBoxComponent checked={value} block={false} formGroup={false} readOnly hideLabel />
                            <span>
                                <I18n id={`communications.communicationsTypes.${key}`} />
                            </span>
                            <Image src="images/chevromRight.svg" className="svg-icon svg-caret" />
                        </Link>
                    </li>
                );
            });
    };

    handleBack = () => {
        const { dispatch } = this.props;

        dispatch(goBack());
    };

    renderContent = () => {
        const { communicationTypes } = this.props;

        return (
            communicationTypes && (
                <form className="above-the-fold">
                    <section className="container--layout flex-grow align-items-center">
                        <Grid className="form-content">
                            <Row className="justify-content-center">
                                <Col sm={12} md={9} lg={6} xl={6} className="col col-12">
                                    <p className="text-lead">
                                        <I18n id="settings.notificationsConfiguration.title" />
                                    </p>
                                    <ul className="navigational-list navigational-list--notifications">
                                        {this.renderCommunicationTypes()}
                                    </ul>
                                </Col>
                            </Row>
                        </Grid>
                    </section>
                </form>
            )
        );
    };

    render() {
        const { fetching, isDesktop, embeddedInV3Shell } = this.props;
        const isShellActive = embeddedInV3Shell && isUxDashboardImprovementsEnabled();
        return (
            <Fragment>
                <div className="admin-detail-head px-0">
                    {(isDesktop || !isShellActive) && (
                        <Head
                            backLinkTo="/settings"
                            headerClassName={!isDesktop && "blue-main-header-mobile"}
                            centerElement={!isDesktop && this.renderTitleMobile}
                            hideMobileMenu={!isDesktop}
                        />
                    )}
                    {isDesktop && (
                        <h1>
                            <I18n id="settings.notificationsConfiguration" />
                        </h1>
                    )}
                </div>
                <MainContainer showLoader={fetching}>{this.renderContent()}</MainContainer>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    communicationTypes: selectors.getCommunicationTypes(state),
    fetching: selectors.isFetching(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(NotificationsConfiguration);
